import { call, put, takeLatest } from "redux-saga/effects";
import { API_CART, API_COUNT_CART } from "../api";
import API from "core/networks/API";
import { AxiosResponse } from "axios";
import {
  FETCH_COUNT_CART_REQUEST,
  FETCH_LIST_CART_REQUEST,
  fetchCountCartError,
  fetchCountCartSuccess,
  fetchListCartError,
  fetchListCartSuccess,
  UPDATE_CART_REQUEST,
  updateCartError,
  updateCartSuccess,
} from "./actions";
import { route } from "core/router";

function* getListCart(_action: any) {
  try {
    const data = _action?.payload || {};
    const response: AxiosResponse = yield call(API.get, API_CART, data);
    yield put(fetchListCartSuccess(response.data.data));
  } catch (error) {
    yield put(fetchListCartError(error as Error));
  }
}

function* getCountCart() {
  try {
    const data = {};
    const response: AxiosResponse = yield call(API.get, API_COUNT_CART, data);
    yield put(fetchCountCartSuccess(response.data.data));
  } catch (error) {
    yield put(fetchCountCartError(error as Error));
  }
}

function* cart(_action: any) {
  try {
    const data = _action?.payload;
    const url = route(API_CART, _action?.payload);
    const response: AxiosResponse = yield call(API.post, url, data);
    const resMap = {
      data: response.data.data,
      type: _action?.payload?.action,
    };
    yield put(updateCartSuccess(resMap));
  } catch (error) {
    yield put(updateCartError(error as Error));
  }
}

export default function* CartSaga() {
  yield takeLatest(FETCH_LIST_CART_REQUEST, getListCart);
  yield takeLatest(UPDATE_CART_REQUEST, cart);
  yield takeLatest(FETCH_COUNT_CART_REQUEST, getCountCart);
}
